import { render, staticRenderFns } from "./assetSimple.vue?vue&type=template&id=e80f19ce&scoped=true&"
import script from "./assetSimple.vue?vue&type=script&lang=js&"
export * from "./assetSimple.vue?vue&type=script&lang=js&"
import style0 from "./assetSimple.vue?vue&type=style&index=0&id=e80f19ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80f19ce",
  null
  
)

export default component.exports